/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconLetterK = createReactComponent("outline", "letter-k", "IconLetterK", [["path", { "d": "M7 4l0 16", "key": "svg-0" }], ["path", { "d": "M7 12h2l8 -8", "key": "svg-1" }], ["path", { "d": "M9 12l8 8", "key": "svg-2" }]]);

export { IconLetterK as default };
//# sourceMappingURL=IconLetterK.mjs.map
